const Logo = ({ size = "h-11" }) => (
    <span className="flex items-center" data-testid="brand-logo">
        <img src="/logo.png" alt="Bangde Construction LLP logo" className={`${size} w-auto rounded-lg`} />
    </span>
);

export default Logo;
